var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BehaviorSubject, from, ReplaySubject, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
var ItemList = /** @class */ (function () {
    function ItemList(_callback, _options) {
        var _this = this;
        this._callback = _callback;
        this._options = _options;
        this._items = new BehaviorSubject([]);
        this._itemsWhenReset = new ReplaySubject(1);
        this._activeIndex = new BehaviorSubject(0);
        this._reset$ = new Subject();
        this._reseted = true;
        this.loading = new BehaviorSubject(false);
        this.isSilentLoading = false;
        this.loaded = false;
        this.reached = false;
        this.empty = true;
        this.failed = false;
        this.reset$ = this._reset$.asObservable();
        this.items = this._items.asObservable();
        this.itemsWhenReset = this._itemsWhenReset.asObservable();
        this.activeIndex = this._activeIndex.asObservable();
        this.activeItem = this.activeIndex.pipe(map(function (index) { return ({
            index: index,
            item: _this._items.value[index]
        }); }));
        this._options = __assign({ count: 20 }, this._options);
    }
    Object.defineProperty(ItemList.prototype, "canMore", {
        get: function () {
            return this.reached === false && this.loading.value === false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ItemList.prototype, "count", {
        get: function () {
            return this._items.value.length;
        },
        enumerable: true,
        configurable: true
    });
    ItemList.prototype.getAllItems = function () {
        return this._items.value;
    };
    ItemList.prototype.activateIndex = function (index) {
        if (index === void 0) { index = 0; }
        this._activeIndex.next(index);
    };
    ItemList.prototype.next = function (offset, clearItemsAfterLoad) {
        var _this = this;
        if (offset === void 0) { offset = this._items.value.length; }
        if (clearItemsAfterLoad === void 0) { clearItemsAfterLoad = false; }
        if (this.reached || this.loading.value) {
            return false;
        }
        this.loading.next(true);
        this.failed = false;
        from(this._callback(offset, this._payload))
            .subscribe(function (items) {
            items = items || [];
            _this.done(items);
            if (clearItemsAfterLoad) {
                _this._items.next(items);
            }
            else {
                _this._items.next([].concat(_this._items.value).concat(items));
            }
        }, function (error) {
            _this._items.next([]);
            _this.failed = true;
            _this.done([]);
        });
    };
    ItemList.prototype.done = function (items) {
        if (this._reseted) {
            this._itemsWhenReset.next(items);
        }
        this._reseted = false;
        this.loaded = true;
        this.loading.next(false);
        this.empty = (items.length === 0) && this._items.value.length === 0;
        if (items == null || items.length < this._options.count && this.loaded === true) {
            this.reached = true;
        }
    };
    ItemList.prototype.reset = function (payload) {
        this._reseted = true;
        this._payload = payload;
        this.loaded = false;
        this.empty = true;
        this.reached = false;
        this._items.next([]);
        this.activateIndex(0);
        this._reset$.next();
    };
    ItemList.prototype.refresh = function (payload, silent) {
        if (silent === void 0) { silent = false; }
        this.isSilentLoading = silent;
        if (silent) {
            this._payload = payload;
            this.loaded = false;
            this.empty = true;
            this.reached = false;
            this.next(0, true);
        }
        else {
            this.reset(payload);
            this.next();
        }
    };
    ItemList.prototype.updateItemAtIndex = function (index, item) {
        var items = [].concat(this._items.value);
        items[index] = item;
        this._items.next(items);
    };
    return ItemList;
}());
export { ItemList };
//# sourceMappingURL=item-list.js.map